<template>
    <div class="course-box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/onlineTraining/statistics/Index' }">培训统计表</el-breadcrumb-item>
            <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="年度：">
                <el-select v-model="formInline.year">
                    <el-option v-for="item in yearList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="表格：">
                <el-select v-model="formInline.trainingStatisticsType">
                    <el-option label="人数表" value="user_count"></el-option>
                    <el-option label="次数表" value="count"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button v-buttonAuth="'system:trainingStatistics:export'" @click="exportExcel()" size="small"
                    type="primary">导出</el-button>
            </el-form-item>
        </el-form>
        <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading">
        </my-table>
        <!-- <div class="main-pagination">
        <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
      </div> -->
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import { deptMemberPage, deptList } from '@/api/dept.js'
import { downloadFile } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/course';
export default {
    components: {
        MyTable,
        Pagination,
    },
    data () {
        return {
            yearList: [],
            formInline: {
                year: '',
                trainingStatisticsType: 'user_count',
            },
            customColumns: [
                { label: '部门名称', prop: 'hostDeptName' },
                { label: '任务分类', prop: 'taskTypeText' },
                { label: '1月', prop: 'january' },
                { label: '2月', prop: 'february' },
                { label: '3月', prop: 'march' },
                { label: '4月', prop: 'april' },
                { label: '5月', prop: 'may' },
                { label: '6月', prop: 'june' },
                { label: '7月', prop: 'july' },
                { label: '8月', prop: 'august' },
                { label: '9月', prop: 'september' },
                { label: '10月', prop: 'october' },
                { label: '11月', prop: 'november' },
                { label: '12月', prop: 'december' },
                { label: '合计', prop: 'total' },
            ],
            isLoading: false,
            tableData: [],
            pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
            deptId: '',

        }
    },
    created () {
        this.deptId = this.$route.query.deptId;
        const year = new Date().getFullYear();
        this.yearList = [];
        for (let i = year - 5; i <= year + 5; i++) {
            this.yearList.push({ label: i, id: i });
        };
        this.formInline.year = new Date().getFullYear();
        if (!this.deptId) {
            this.$message({
                message: '请选择部门',
                type: 'warning'
            });
            this.$router.go(-1)
            return false
        }
        this.getData();
    },
    methods: {
        search () {
            this.pageInfo.currentPage = 1;
            this.getData();
        },
        //  改变分页及大小
        callFather (data) {
            this.pageInfo.currentPage = data.currentPage;
            this.pageInfo.pageSize = data.pageSize;
            this.getData();
        },
        //  获取数据
        async getData () {
            const params = {
                ...this.formInline,
                hostDeptId: this.deptId,
            };
            const res = await courseApi.trainingStatistics(params);
            this.tableData = res.data;
            // this.pageInfo.total = res.data.total;
        },
        async exportExcel () {
            const type = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const params = {
                ...this.formInline,
                hostDeptId: this.deptId,
            };
            downloadFile(await courseApi.trainingStatistics(params, { responseType: 'blob', isExport: true }), type, `${this.formInline.year}年${this.formInline.trainingStatisticsType=='user_count'?'人数表':'次数表'}-${new Date().getTime()}`);
        },
    }
}
</script>

<style lang="scss" scoped>
.course-box {
    height: 100%;

    .user-search {
        margin-top: 20px;
    }

    .operate {
        margin-left: 10px;

        &:first-child {
            margin-left: 0;
        }
    }

    .view-list {
        width: 70%;
        margin: 0 auto;
        font-size: 16px;

        .view-item {
            display: flex;
            align-items: flex-start;
            padding: 5px 0;

            .view-label {
                width: 100px;
                text-align: right;
            }
        }
    }
}
</style>
<style lang="scss">
.el-loading-mask {
    z-index: 5000 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/onlineTraining/statistics/details.vue